import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { http } from '../../components/helper';

 
export const OfferProduct = createAsyncThunk(
  'offers/products',
  async (payload) => {
    const response = await http.post('productsbyids',payload);
    return response.data;
  }
);

const initialState = {
  offerproduct: [],
  status: 'idle',
  error: null,
};


const offerProductSlice = createSlice({
  name: 'OfferProducts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(OfferProduct.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(OfferProduct.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.offerproduct = action.payload;
      })
      .addCase(OfferProduct.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

 
export default offerProductSlice.reducer;